<template>

  <div class="my-container">
    <div class="left-column">
      <div
        class="my-card"
        v-for="(item, index) in items"
        :key="index"
      >
        <div class="card-content">
          <h2>{{item.nombre}}</h2>
          <p>Content for the first card.</p>
        </div>
        <div class="card-right">
          <!-- <p class="fs-1"><strong>${{ item.precio }}</strong></p> -->
          <p class="font-bold">${{ item.precio }}</p>
        </div>
      </div>
    </div>

    <div class="right-column">
      <h2>Total: {{ total }}</h2>
      <!-- <p>This column is fixed and takes 25% of the width.</p> -->

      <div id="paypal"></div>
    </div>
  </div>
  <!-- <div>
    <h2>SHOPPINGCART</h2>
    <div id="paypal"></div>
    <div>
      <b-button @click="conektaCreateCustomer" variant="success">Conekta</b-button>
    </div>
  </div> -->
</template>
<script>
import { loadScript } from "@paypal/paypal-js";
import Vue from 'vue';
import axios from 'axios';
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      conectaAPIBaseUrl:'https://api.conekta.io',
      loading: true,
      tiposBloque: [],
      isLoaded: false,
      total: 0,
      items: [],
      purchaseUnits: [],
    };
  },
  methods: {
    async conektaCreateCustomer() {

      try {
        const response = await axios.post('https://api.conekta.io/customers',
          {
            name: 'Cesar Riojas',
            email: 'riojasmx@gmail.com'
          },
          {
            headers: {
              'Accept': 'application/vnd.conekta-v2.0.0+json',
              'Content-Type': 'application/json'
            },
            auth: {
              username: 'key_lJsra9mHKYThAYC6mA55RK2',
              password: ''
            }
          }
        );

        console.log('Customer created:', response.data);
        this.conecktaCreateURLCheckout(response.data.id);

      } catch (error) {
        console.error('Error creating customer:', error.response ? error.response.data : error.message);
      }
    },
    async conecktaCreateURLCheckout(customerId) {
      try {
        const response = await axios.post('https://api.conekta.io/orders',
          {
            currency: "MXN",
            customer_info: {
              customer_id: customerId
            },
            line_items: [{
              name: "Box of Cohiba S1s",
              unit_price: 35000,
              quantity: 1
            }],
            shipping_lines: [{
              amount: 0
            }],
            checkout: {
              allowed_payment_methods: ["cash", "card", "bank_transfer"],
              type: "HostedPayment",
              success_url: "https://www.mysite.com/payment/confirmation",
              failure_url: "https://www.mysite.com/payment/failure",
              redirection_time: 4 //Tiempo de Redirección al Success-Failure URL, umbrales de 4 a 120 seg.
            },
          },
          {
            headers: {
              'Accept': 'application/vnd.conekta-v2.0.0+json',
              'Content-Type': 'application/json'
            },
            auth: {
              username: 'key_lJsra9mHKYThAYC6mA55RK2',
              password: ''
            }
          }
        );

          console.log('URL:', response.data);

        } catch (error) {
          console.error('Error creating customer:', error.response ? error.response.data : error.message);
        }
    },
    itemsToPaypalPurchaseUnits(items) {
      this.purchaseUnits = items.map(item => {
        return {
          amount: {
            value: +item.precio
          },
          description: item.nombre,
          reference_id: item.cve_tema,
        };
      });
    },
    setPaypalButtons() {},
    ...mapGetters(['obtenerCarrito', 'getTotalAmount']),
  },
  created() {

    this.items = this.$route.params.items;

    this.items.forEach(item => {
      this.total += +item.precio;
    });
    this.itemsToPaypalPurchaseUnits(this.items);
  },
  async mounted() {
    let paypal;

    try {
      paypal = await loadScript({
        clientId: "AUqKoQKTGl8_lloipIkZWEcwaVQNX4IvdumtAA9MsgLjnuOF02IwwrlBOA6mjQh0w4oABc2ac145XHbS",
        // components: ["buttons", "marks", "messages"],
        disableFunding: ['card'],
        environment: 'sandbox',
        currency: 'MXN',

      });
    } catch (error) {
        console.error("failed to load the PayPal JS SDK script", error);
    }

    if (paypal) {
      try {
        await paypal.Buttons({
          createOrder: async (data , actions) => {
            return actions.order.create({
              purchase_units: this.purchaseUnits,

            });
          },
          async onApprove(data) {
          },
          onCancel(data) {
          },
          onError(error) {
          },
          async onInit() {
          },
          async onShippingAddressChange(data, actions) {
          },
          async onShippingOptionsChange(data, actions) {
          },
        }).render("#paypal");
      } catch (error) {
        console.error("failed to render the PayPal Buttons", error);
      }
    }

  },
  computed: {
    getTotalAmount() {
      return this.getTotalAmount;
    }
  },
}
</script>
<style scoped>

.my-container {
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 100vh;
}

.left-column {
  width: 75%;
  padding: 10px;
  box-sizing: border-box;
  background-color: #f4f4f4;
}

.right-column {
  width: 25%;
  padding: 10px;
  box-sizing: border-box;
  background-color: #ddd;
  position: fixed;
  right: 0;
  height: 100%;
}

.my-card {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.panel {
  padding: 0 !important;
}

.card-content {
    flex-grow: 1;
}

.card-right {
    margin-left: 20px; /* Espacio entre el contenido y la columna derecha */
}
</style>



// WEBPACK FOOTER //
// src/components/AppLms/e-commerce/shopping_cart/shopping_cart.vue